import { Component, type ErrorInfo, type ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '@fiado/react-kit';

interface Props {
    children: ReactNode;
}
interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    override componentDidCatch(error: Error, info: ErrorInfo): void {
        Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
    }

    handleReload = (): void => {
        window.location.reload();
    };

    override render(): ReactNode {
        if (this.state.hasError) {
            return (
                <div
                    role="alert"
                    className="min-h-screen flex flex-col items-center justify-center gap-4"
                >
                    <h1 className="text-2xl font-semibold">Algo salió mal</h1>
                    <p className="text-muted-foreground">Recarga la página o prueba más tarde.</p>
                    <Button onClick={this.handleReload}>Recargar</Button>
                </div>
            );
        }
        return this.props.children;
    }
}
